// Account Registration module

define('modules/User/Registration',[
    'jquery',
    'global/all',
    './Users.Forms',
    './Users.Selectors'
], function ($, Roc, UsersForms, Selectors) {
    'use strict';

    var registrationOptions;

    // Forms definitions
    var forms = UsersForms;


    function isTermsOfRegistrationAccepted() {
        return $('#register_terms_accept').is(':checked');
    }

    function register() {
        var registrationFormDefinition = forms.PackardRegistration;
        var $formWrapper = $(registrationFormDefinition.Fields[0].Field).closest('.formee');
        var $errorContainer = Roc.UI.getErrorSummaryWrapper($formWrapper);
        $errorContainer.html('');

        var isValid = Roc.Validation.validateForm(registrationFormDefinition, true, false);
        var termsAccepted = isTermsOfRegistrationAccepted();
        if (isValid && termsAccepted) {
            Roc.Core.lockButton(Selectors.btns.register);
            var requestData = Roc.Validation.getFieldValues(registrationFormDefinition);
            requestData.authenticateUser = registrationOptions.authenticateUser;
            requestData.duringCheckout = registrationOptions.duringCheckout;

            $.ajax({
                url: '/ajax/Register',
                type: 'POST',
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify(requestData),
                beforeSend: registrationOptions.beforeSend || null,
                complete: function (xhr) {
                    var response = xhr.responseJSON || {};
                    if (response.errorMessage) {
                        Roc.UI.displayErrorPopup(response.errorMessage, 'Registration Error');
                    }
                    Roc.Core.releaseLockedButton(Selectors.btns.register);
                    Roc.EventManager.notify(Roc.Events.users.REGISTER, xhr);
                }
            });

        } else if (isValid && !termsAccepted) {
            Roc.UI.displayErrorPopup('You must accept the Terms and Purchase Policy.', 'Error');
        }
        return isValid;
    }

    function clearRegistrationFormEvt() {
        $(document)
            .off('click', Selectors.btns.clear)
            .on('click', Selectors.btns.clear, function () {
                Roc.Forms.clearData(forms.PackardRegistration, false);
            });
    }

    function registerEvt() {
        $(document).on('click', Selectors.btns.register, function () {
            register();
        });
    }

    //function emailNotificationsTypeChangeEvt() {
    //    $(document)
    //        .off('change', 'input[name="email_notifications"]')
    //        .on('change', 'input[name="email_notifications"]', function () {
    //            // copy value to hidden field
    //            $('input#register_email_notifications').val($(this).val());
    //        });
    //}

    // START: Events binding

    function countryChangeEvt() {
        $(document)
            .off('change', Selectors.fields.country)
            .on('change', Selectors.fields.country, function () {
                updateRegionStateDisplay();
            });

    }
    function bindAddressAutoCompleteEvt(country, isStateRequired) {
        if (window.RocConfig.google.enableAddressAutocomplete !== true) {
            return;
        }

        country = country || window.RocConfig.defaultCountryCode;
        Roc.UI.addresscomplete('#register_address1', {
            country: country,
            autopopulate: true,
            fieldsMapping: {
                "STREET_ADDRESS_AND_NUMBER": '#register_address1',
                "COUNTRY": '#register_country',
                "ZIP": '#register_zip',
                "CITY": '#register_city',
                "STATE_OR_REGION": isStateRequired ? '#register_state' : '#register_region'
            },
            validation: {
                componentsToValidate: ['street_number'],
                onValidationFailed: function (sender) {
                    Roc.UI.warning('Unable to determine street number. Please verify your address is correct.');
                }
            }
        });
    }

    function bindZipCodeLookUpEvt(country, isStateRequired) {
        if (window.RocConfig.google.enableAddressAutocomplete !== true) {
            return;
        }
        country = country || window.RocConfig.defaultCountryCode;
        Roc.UI.ziplookup('#register_zip', {
            country: country,
            fieldsMapping: {
                "CITY": '#register_city',
                "STATE_OR_REGION": isStateRequired ? '#register_state' : '#register_region'
            }
        });
    }

    function bindRegistrationEvents() {
        //emailNotificationsTypeChangeEvt();
        clearRegistrationFormEvt();
        registerEvt();
        countryChangeEvt();

        Roc.EventManager.bind(Roc.Events.users.REGISTER, function (xhr) {
            var response = xhr.responseJSON || {};
            if (response.success && response.redir) {
                Roc.Core.lockButton(Selectors.btns.register);
                window.location.replace(response.redir);
            }
        });
    }

    // START: Private Methods
    function updateRegionStateDisplay() {
        var $country = $(Selectors.fields.country);
        var $regionInput = $(Selectors.fields.region);
        var $regionWrapper = $(Selectors.wrappers.region);
        var $stateWrapper = $(Selectors.wrappers.state);

        var isStateRequired = $country.find(':selected').data('isstaterequired');

        if (isStateRequired) {
            $stateWrapper.show();
            $regionWrapper.hide();
            $regionInput.val('');
            $stateWrapper.find('[data-country]').hide();
            $stateWrapper.find('[data-country=' + $country.val() + ']').show();
        } else {
            $stateWrapper.hide();
            $regionWrapper.show();
        }

        bindZipCodeLookUpEvt($country.val(), isStateRequired);
        bindAddressAutoCompleteEvt($country.val(), isStateRequired);
    }

    // Start: Public Methods

    function init(options) {
        registrationOptions = options || {};
        bindRegistrationEvents();
        updateRegionStateDisplay();
    };

    var Registration = {
        forms: forms,
        init: init,
        register: register
    };

    Roc.Logger.debug('Registration.js Loaded:', Registration);

    return Registration;
});
